import * as _ from 'lodash';
import { Formio } from 'formiojs';
var FetchProvider = /** @class */ (function () {
    function FetchProvider(options) {
        if (options === void 0) { options = {}; }
        this.options = _.merge({}, this.defaultOptions, options);
    }
    Object.defineProperty(FetchProvider, "key", {
        get: function () {
            return 'fetch';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FetchProvider, "displayName", {
        get: function () {
            return 'Fetch';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FetchProvider, "availableToSourceOptions", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FetchProvider.prototype, "defaultOptions", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    FetchProvider.prototype.getData = function (params) {
        return new Formio.Promise(function (resolve, reject) {
            resolve();
        });
    };
    return FetchProvider;
}());
export { FetchProvider };
